import { differenceInDays } from 'date-fns';
import useAuth from '@sdk/authentication/useAuth';
import useConfig from '@sdk/config/useConfig';

import { MODAL_SHOWN_TIMES_LIMIT } from '@web/account/billingWarnings/MissingBillingAddressModal/missingBillingAddress.consts';
import { getIsAddressUpdateRequired } from '@web/account/utils/getIsAddressUpdateRequired';
import { useBillingInfo } from '@web/account/billing/BillingInfoContext';
import { BILLING_ADDRESS_WARNING_KEY, TAX_TIP_VISIBLE_DAYS } from '@web/account/constants';

export const useEditBillingTopTip = (hasTax: boolean) => {
  const { currentUser } = useAuth();
  const { billingInfo } = useBillingInfo();
  const { FEATURE_FLAGS } = useConfig();
  const { isToastBilling, isPremium } = currentUser.org;
  const billingAddressWarningShowedTimes =
    currentUser.settings.clientFlags[BILLING_ADDRESS_WARNING_KEY]?.count || 0;
  const isWarningsLimitExceeded = billingAddressWarningShowedTimes >= MODAL_SHOWN_TIMES_LIMIT;

  const isAddressTipVisible =
    FEATURE_FLAGS.TAX_CALCULATIONS_ENABLED &&
    getIsAddressUpdateRequired({
      isManager: currentUser.isManager,
      isToastBilling,
      isPremium,
      billingInfo,
    });

  const isTaxTipVisible =
    !isAddressTipVisible &&
    hasTax &&
    billingInfo.taxationStartedAt &&
    differenceInDays(new Date(), billingInfo.taxationStartedAt) < TAX_TIP_VISIBLE_DAYS;

  return {
    billingInfo,
    isAddressTipVisible,
    shouldForceAddressUpdate: isWarningsLimitExceeded,
    isTaxTipVisible,
  };
};
